import type React from "react"

export const CircleDot: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Circle Dot</title>
    <circle cx="12.5" cy="12" r="11" fill="white" stroke-width="3" />
    <circle cx="12.5" cy="12" r="5" stroke-width="3" />
  </svg>
)
